import { render, staticRenderFns } from "./admissionNotice.vue?vue&type=template&id=aa4dae8c&scoped=true&"
import script from "./admissionNotice.vue?vue&type=script&lang=js&"
export * from "./admissionNotice.vue?vue&type=script&lang=js&"
import style0 from "./admissionNotice.vue?vue&type=style&index=0&id=aa4dae8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4dae8c",
  null
  
)

export default component.exports